export enum HexagonButtonSizes {
  SM = 'small',
  MD = 'medium',
  LG = 'large',
}
